import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {arrayToSet, filterMapByKeys} from '../../../atUtils'
import {UserTeamAssignmentType} from '../constants'
import {ManagementAssignmentsSelection} from '../../../constants'

const initialState = {
    fullUserInfo: {
        firstName: null,
        lastName: null,
        middleInitial: null,
        username: null,
        email: null,
        password: null,
        retypedPassword: null,
        userGroupId: null,
        timeZoneGroupId: null,
        hireDate: (new Date()).toJSON(),
        releaseDate: null,
        enabled: false,
        enabledInOtherProduct: false,
        overtimeLevel: 3,
        accessRights: [],
        rates: [],
        requiresTTApproval: false,
        initialSchedule: [],
        defaultInitialSchedule: true,
        workSchedule: [],
    },
    userGroupRowData: {
        groupId: null,
        newGroupCreating: false,
        newUserGroupName: '',
    },
    timeZoneGroupRowData: {
        groupId: null,
        newGroupCreating: false,
        timeZoneGroupsOffset: {},
        newTimeZoneGroup: null,
    },
    userTeamAssignmentsData: {
        teamAssignmentType: UserTeamAssignmentType.NO,
        assignedGroups: [],
        assignedUsers: [],
        assignedUsersCount: 0,
    },
    userManageAssignmentsData: {
        managementAssignmentsSelection: ManagementAssignmentsSelection.SELECTED,
        customers: {},
        projects: {},
        tasks: {},
        customerAssignments: [],
        projectAssignments: [],
        taskAssignments: [],
        taskCountsByProjects: {},
        projectCountsByCustomers: {}
    },
    managementAssignmentsCounters: {
        loading: false,
        loaded: true,
        customers: 0,
        projects: 0,
        tasks: 0
    },
    allApprovers: {},
    extendedData: {
        lastLoginTime: null,
        firstTTDate: null,
        firstRequestDate: null,
        hasTimeTrack: false,
        lastOtherProductAdmin: false,
        lastLicensesManager: false,
        currentTime: (new Date()).toJSON(),
        isAllowedToSeeAllUsersTT: false,
    },
    providerErrors: {},
    passwordValidationResult: null,
    hasLeavesOrTTBeforeNewHireDateError: false,
}

export default handleActions({
    [ActionTypes.FULL_USER_INFO_SET]: (state, {payload: userInfoChanges}) => ({
        ...state,
        fullUserInfo: {...state.fullUserInfo, ...userInfoChanges}
    }),
    [ActionTypes.EXTENDED_DATA_UPDATE]: (state, {payload: extendedData}) => ({
        ...state,
        extendedData: {...state.extendedData, ...extendedData}
    }),
    [ActionTypes.USER_PANEL_PASSWORD_VALIDATION_RESULT_SET]: (state, {payload: passwordValidationResult}) => ({
        ...state,
        passwordValidationResult
    }),
    [ActionTypes.USER_GROUP_DATA_SET]: (state, {payload: data}) => ({
        ...state,
        userGroupRowData: {...state.userGroupRowData, ...data},
    }),
    [ActionTypes.TIME_ZONE_GROUP_DATA_SET]: (state, {payload: data}) => ({
        ...state,
        timeZoneGroupRowData: {...state.timeZoneGroupRowData, ...data},
    }),
    [ActionTypes.USER_MANAGE_ASSIGNMENTS_DATA_SET]: (state, {payload: userManageAssignmentsData}) => ({
        ...state,
        userManageAssignmentsData: {...state.userManageAssignmentsData, ...userManageAssignmentsData}
    }),
    [ActionTypes.USER_MANAGEMENT_ASSIGNMENTS_SELECTION_SET]: (state, {payload: managementAssignmentsSelection}) => ({
        ...state,
        userManageAssignmentsData: {
            ...state.userManageAssignmentsData,
            managementAssignmentsSelection: managementAssignmentsSelection,
        }
    }),
    [ActionTypes.USER_TEAM_ASSIGNMENTS_DATA_SET]: (state, {payload: userTeamAssignmentsData}) => ({
        ...state,
        userTeamAssignmentsData: {...state.userTeamAssignmentsData, ...userTeamAssignmentsData}
    }),
    [ActionTypes.USER_DATA_SET]: (state, {payload: data}) => ({
        ...state,
        ...data
    }),
    [ActionTypes.ALL_APPROVERS_SET]: (state, {payload: allApprovers}) => ({
        ...state,
        allApprovers: allApprovers,
    }),
    [ActionTypes.USER_PANEL_ERROR_ADD]: (state, {payload: providerErrors}) => ({
        ...state,
        providerErrors: {...state.providerErrors, ...arrayToSet(providerErrors)}
    }),
    [ActionTypes.USER_PANEL_ERRORS_SET]: (state, {payload: providerErrors}) => ({
        ...state,
        providerErrors: providerErrors
    }),
    [ActionTypes.USER_PANEL_ERRORS_CLEAR]: (state) => ({
        ...state,
        providerErrors: {},
        hasLeavesOrTTBeforeNewHireDateError: false,
    }),
    [ActionTypes.USER_PANEL_ERRORS_REMOVE]: (state, {payload: errors}) => ({
        ...state,
        providerErrors: filterMapByKeys(state.providerErrors, errors)
    }),
    [ActionTypes.USER_PANEL_HAS_LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE_ERROR]: (state, {payload: hasLeavesOrTTBeforeNewHireDateError}) => ({
        ...state,
        hasLeavesOrTTBeforeNewHireDateError: hasLeavesOrTTBeforeNewHireDateError
    }),
    [ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOADED_SET]: (state, {payload: loaded}) => ({
        ...state,
        managementAssignmentsCounters: {
            ...state.managementAssignmentsCounters,
            loaded
        },
    }),
    [ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD]: (state) => ({
        ...state,
        managementAssignmentsCounters: {
            ...state.managementAssignmentsCounters,
            loading: true
        },
    }),
    [ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_SUCCESS]: (state, {payload: {customers, projects, tasks}}) => ({
        ...state,
        managementAssignmentsCounters: {
            loading: false,
            loaded: true,
            customers,
            projects,
            tasks
        },
    }),
    [ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_FAILURE]: (state, {payload: error}) => ({
        ...state,
        managementAssignmentsCounters: {
            ...state.managementAssignmentsCounters,
            loading: false,
            loaded: true
        },
    }),
}, initialState)


// WEBPACK FOOTER //
// ./web/js/panels/user/userData/reducer.js